import { UserRoles } from '../store/models/User';

export const isMemberRole = (roles: UserRoles[] | null) => {
  if (!roles) {
    return null;
  }

  return roles?.some((role) => [UserRoles.ADMIN, UserRoles.VIEWER].includes(role));
};
